export default __webpack_public_path__ + "static/media/004-toffee.22a23d54.svg";